import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-pfeil-next-red",
  "use": "various-pfeil-next-red-usage",
  "viewBox": "0 0 33 33",
  "content": "<symbol viewBox=\"0 0 33 33\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-pfeil-next-red\"><g fill=\"#e3000f\" fill-rule=\"evenodd\"><path fill-rule=\"nonzero\" d=\"M28.505 17L17.42 6l-1.915 1.9 9.17 9.1-9.17 9.1L17.42 28z\" /><path d=\"M26 15.338v3H5v-3z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol